import Signin from "pages/Signin";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "pages/Home";
import { authLoader, withAuth } from "helpers/utils";
import Page from "components/Page";
import Items from "pages/Items";
import NotFound from "pages/NotFound";
import Requests from "pages/Requests";
import Transfers from "pages/Transfers";
import ItemDetails from "pages/ItemDetails";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Signin />,
    loader: withAuth((u) =>
      authLoader(u, {
        redirectIfLoggedIn: "/home",
      })
    ),
    errorElement: <NotFound />,
  },
  {
    path: "/home",
    element: <Page component={<Home />} />,
    loader: withAuth((u) =>
      authLoader(u, { roles: ["Admin", "Super Admin", "QC"] })
    ),
    errorElement: <NotFound />,
  },
  {
    path: "/items",
    element: <Page component={<Items />} />,
    loader: withAuth((u) => authLoader(u, { roles: ["Admin", "Super Admin"] })),
    errorElement: <NotFound />,
  },
  {
    path: "/items/:id",
    element: <Page component={<ItemDetails />} />,
    loader: withAuth((u) => authLoader(u, { roles: ["Admin", "Super Admin"] })),
    errorElement: <NotFound />,
  },
  {
    path: "/requests",
    element: <Page component={<Requests />} />,
    loader: withAuth((u) => authLoader(u, { roles: [] })),
    errorElement: <NotFound />,
  },
  {
    path: "/transfers",
    element: <Page component={<Transfers />} />,
    loader: withAuth((u) =>
      authLoader(u, { roles: ["Admin", "Super Admin", "QC"] })
    ),
    errorElement: <NotFound />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function Router() {
  return <RouterProvider router={routes} />;
}
